<div class="flex gap-2 justify-end pr-[0.25em]">
  @if (params.data.most_recent_shared_link_relative) {
    <a
      panButton
      icon="receipt"
      fill="outline"
      color="info"
      [href]="params.data.most_recent_shared_link_relative"
      target="_blank"
      data-testid="report_portal_most_recent_incidents_report_link"
    >
      Filtered
    </a>
  }

  <a
    panButton
    icon="receipt"
    fill="outline"
    color="info"
    [href]="params.data.all_theft_shared_link_relative"
    target="_blank"
    data-testid="report_portal_all_incidents_report_link"
  >
    All
  </a>

  <a panButton color="info" (click)="showAccessLog.set(true)" data-testid="access-log-button">Access Log</a>
</div>

<app-pan-modal [isOpen]="showAccessLog()" (modalClose)="showAccessLog.set(undefined)" data-testid="access-log-modal">
  <div header>Access Log</div>

  <div body>
    @if (showAccessLog()) {
      <app-access-log-dialog
        [branchId]="params.data.branch_id"
        [locationId]="params.data.location_id"
        [allShare]="params.data.all_theft_share_key"
        [recentShare]="params.data.most_recent_share_key"
      ></app-access-log-dialog>
    }
  </div>

  <div footer>
    <app-pan-button color="info" fill="outline" panModalClose>Close</app-pan-button>
  </div>
</app-pan-modal>
